import classNames from 'classnames';
import type { MapObject } from '~/common/types';
import TextArea from '~/components2/forms/TextArea';
import { useCivilDrawStore } from '../../civilDrawStoreContext';

interface ObjDescriptionProps {
  currentObject: MapObject;
}

export default function ObjDescription({ currentObject }: ObjDescriptionProps) {
  const store = useCivilDrawStore();
  const isMetadata = (): boolean => {
    if (currentObject.type === 'arrow') {
      const p = currentObject.properties;
      if (p.subtype === 'metadata' && p.font !== undefined) {
        return true;
      }
    }

    return false;
  };

  return (
    <div className="my-6">
      <span className="text-base font-bold">Description</span>
      <TextArea
        label=""
        value={currentObject.description}
        onChange={(e) => store.updateObject({ description: e })}
        name="description"
        rows={7}
        className={classNames('whitespace-pre bg-transparent p-1', {
          'font-mono': isMetadata(),
          'font-sans': !isMetadata(),
        })}
      />
    </div>
  );
}
